import Vue from 'vue'
import { Component } from "vue-property-decorator";
import api from '@/api'
import { mapGetters } from "vuex";
import * as typesAccount from "@account/store/types";

@Component({
    computed: {
        ...mapGetters({
            current: typesAccount.CURRENT
        }),
    }
})
export default class FloatingChat extends Vue {
    //
    // ──────────────────────────────────────────────── I ──────────
    //   :::::: D A T A : :  :   :    :     :        :          :
    // ──────────────────────────────────────────────────────────
    //
    //
    isChatOpen: boolean = false //챗봇 오픈여부
    isFloating: boolean = true //플로팅 노출 여부
    comCode: string = "" //회사코드
    personCode: string = "" //사용자코드
    employeeNumber: string = "" //사번
    displayName: string = "" //사용자명
    payType: string = "" //급여유형
    payTypeGubun: string = "" //급여유형구분

    src: String | null = null //Link URL

    chatUrl: String | undefined = ""

    chatbotInfo?: chatbot.ChatbotInfo = {
        chatbotId: 0 //챗봇아이디
        , comCode: this.comCode //회사코드
        , linkUrl: '' //링크 URL
        , isUse: false //사용여부
        , createdId: '' //등록자아이디
        , createdDate: new Date() //등록일
        , updatedId: ''  //수정자아이디
        , updatedDate: new Date() //수정일
        , width: 0 //넓이
        , height: 0 //높이
        , filePath: '' //파일경로
        , fileName: '' //파일명
        , savedFileName: '' //저장파일이름
        , fileSize: 0 //파일크기
    }

    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: G E T T E R S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //
    current!: account.TCurrent;

    get isExist() {
        var elem = document.querySelector('.floating_chat');
        var pflag = false;
        if (window.parent) {
            var pelem = window.parent.document.querySelector('.floating_chat');
            pflag = pelem ? true : false;
        }
        return elem ? true : pflag;
    }

    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: M E T H O D S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //

    /*Chatbot Info 가져오기*/
    getChatbotInfo() {
        this.getChatbot(this.personCode, this.comCode, this.employeeNumber, this.displayName, this.payType, this.payTypeGubun).then((res) => {
            if (res) {
                this.chatbotInfo = res;
                const preScript = document.createElement('script');
                preScript.type = 'text/javascript';
                preScript.innerHTML = `var chatUrl = "${this.chatbotInfo?.linkUrl}"`;
                document.head.appendChild(preScript);
                setTimeout(() => {
                    const script = document.createElement('script');

                    script.src = `${location.protocol}//${location.host}/cm/gres/isusys-chatbot-wrapper/build.js`;

                    if (process.env.NODE_ENV == 'development') {
                        script.src = `https://gwt.isu.co.kr/cm/gres/isusys-chatbot-wrapper/build.js`;
                    }

                    script.async = true;

                    script.defer = true;

                    document.head.appendChild(script);
                }, 10);
            }
        })
    }

    //
    // ────────────────────────────────────────────────────────── I ──────────
    //   :::::: L I F E S T Y L E : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────────
    //
    created() {
        this.comCode = (this.current.company.comCode !== undefined ? this.current.company.comCode : "")
        this.personCode = this.current.user.personCode
        this.employeeNumber = this.current.user.employeeNumber
        this.displayName = this.current.user.displayName
        this.payType = this.current.user.payType
        this.payTypeGubun = this.current.user.payTypeGubun
        this.getChatbotInfo()
    }

    // API
    getChatbot(personCode: string, comCode: string, employeeNumber: string, displayName:string, payType: string, payTypeGubun:string) : Promise<any>{
        return api.get({
          url: '/Common/Chatbot/api/chatbot'
          , params: {
              personCode: personCode
              ,comCode: comCode
              ,employeeNumber: employeeNumber
              ,displayName: displayName
              ,payType: payType
              ,payTypeGubun: payTypeGubun
          }
        })
    }
}

/*챗봇 2024-08-13 추가*/
namespace chatbot {
    export interface ChatbotInfo {
        chatbotId: Number //챗봇아이디
        comCode: String //회사코드
        linkUrl: String //링크 URL
        isUse: boolean //사용여부
        createdId: String //등록자아이디
        createdDate: Date //등록일
        updatedId: String //수정자아이디
        updatedDate: Date //수정일
        width: Number //넓이
        height: Number //높이
        filePath: String //파일경로
        fileName: String //파일명
        savedFileName: String //저장파일이름
        fileSize: Number //파일크기
    }
}